import axios from "../utils/axios";
import stringUtils from "../utils/stringUtils";

const getELTeams = async (accountExternalIds) => {
    const queryString = stringUtils.buildQueryStringList(
        "accountExternalIds",
        accountExternalIds
    );
    return axios.get<never, any>(
        `${process.env.REACT_APP_CASENEST_API_URL}/client/getelteamsbyadvicetype/${queryString}`
    );
};

const teamService = {
    getELTeams,
};

export default teamService;
